import {
    KeycloakEventLegacy,
    KeycloakEventTypeLegacy,
    KeycloakService,
} from '@inoventoryapps/keycloak-angular';
import { environment } from '../../environments/environment';

// export function initializeKeycloak(keycloakService: KeycloakService) {
//     return async () => {
//         try {
//             await keycloakService.init({
//                 config: {
//                     url: environment.keycloak.issuer,
//                     realm: environment.keycloak.realm,
//                     clientId: environment.keycloak.clientId
//                 },
//                 loadUserProfileAtStartUp: false,
//                 initOptions: {
//                     onLoad: 'check-sso',
//                     silentCheckSsoRedirectUri: window.location.origin + '/assets/verify-sso.html',
//                     flow: 'standard',
//                     pkceMethod: 'S256',
//                     checkLoginIframe: false,
//                     scope: 'openid profile email phone'
//                 },
//                 enableBearerInterceptor: true,
//                 bearerPrefix: 'Bearer',
//                 bearerExcludedUrls: ['/assets', '/public', '/cdn.lokos.in']
//             });
//             keycloakService.keycloakEvents$.subscribe({
//                 next: async (event) => {
//                     if (event?.type && KeycloakEventType.OnTokenExpired) {
//                         const tokenRefreshed = await keycloakService.updateToken(0);
//                         if (tokenRefreshed) {
//                             console.log('Token refreshed successfully');
//                         } else {
//                             console.error('Token refresh failed');
//                         }
//                     }
//                 },
//                 error: (err) => console.error('Error during token refresh:', err)
//             });
//         } catch (error) {
//             console.log("Error in keycloak initialise :: ", error);
//         }
//     };
// }
export function initializeKeycloak(
    keycloak: KeycloakService
): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                await keycloak.init({
                    config: {
                        url: environment.keycloak.issuer,
                        realm: environment.keycloak.realm,
                        clientId: environment.keycloak.clientId,
                    },
                    loadUserProfileAtStartUp: false,
                    initOptions: {
                        onLoad: 'check-sso',
                        silentCheckSsoRedirectUri:
                            window.location.origin + '/assets/verify-sso.html',
                        flow: 'standard',
                        pkceMethod: 'S256',
                        checkLoginIframe: true,
                        scope: 'openid profile email phone',
                        dpopEnabled: true,
                        encryptionEnabled: false,
                    },
                    enableBearerInterceptor: true,
                    bearerPrefix: 'DPoP',
                    bearerExcludedUrls: [
                        '/assets',
                        '/public',
                        '/cdn.lokos.in',
                        '/signer',
                    ], // ! add exclues here
                });

                keycloak.keycloakEvents$.subscribe({
                    next: async (event: KeycloakEventLegacy) => {
                        if (event.type !== KeycloakEventTypeLegacy.OnTokenExpired) {
                            return;
                        }

                        try {
                            const refreshed = await keycloak.updateToken(0);
                            if (!refreshed) {
                                await keycloak.login({
                                    redirectUri: window.location.href,
                                });
                            }
                        } catch (refreshError) {
                            console.error('Error during token refresh:', refreshError);
                            await keycloak.login({
                                redirectUri: window.location.href,
                            });
                        }
                    },
                    error: (eventError: unknown) => {
                        console.error('Keycloak event stream error:', eventError);
                    }
                });

                resolve(keycloak);
            } catch (error) {
                reject(error);
            }
        });
    };
}
